import api from './api';

const vaultPaymentService = {
    resolve: (hotelId, accountId) =>
        api.get(`/vault-payment/resolve?hotelId=${hotelId}&accountId=${accountId}`),
    // hotelId picks whose card it is (the hotel's Billing-tab payer); pass the same one to the subscription.
    createSetupIntent: (accountId, accountName, hotelId) =>
        api.post('/vault-payment/setup-intent', { accountId, accountName, hotelId: hotelId ?? null }),
    // VaultPaymentModal passes the vault id as the generic `productId`; the subscription endpoint
    // keys off `vaultId` (to write v2_vault_subscriptions and tag the Stripe sub with vault_id
    // metadata), so translate it here. Without this the payment is never linked to the vault.
    createSubscription: ({ productId, vaultId, ...data }) =>
        api.post('/vault-payment/subscription', { ...data, vaultId: vaultId ?? productId ?? null }),
    getSubscription: (subscriptionId) =>
        api.get(`/vault-payment/subscription?subscriptionId=${subscriptionId}`),
    cancelSubscription: (subscriptionId) =>
        api.post('/vault-payment/subscription/cancel', { subscriptionId }),
    resumeSubscription: (subscriptionId) =>
        api.post('/vault-payment/subscription/resume', { subscriptionId }),
    updateSubscriptionCard: (subscriptionId, paymentMethodId) =>
        api.post('/vault-payment/subscription/update-card', { subscriptionId, paymentMethodId }),
    recordPayment: (data) =>
        api.post('/vault-payment/record', data),
    getPaymentRecord: (vaultId) =>
        api.get(`/vault-payment/record?vaultId=${vaultId}`),
    getInvoicePrice: (retentionYears, hotelId) =>
        api.get(`/vault-payment/invoice-price?retentionYears=${retentionYears}${hotelId ? `&hotelId=${hotelId}` : ''}`),
    getInvoice: (vaultId) =>
        api.get(`/vault-payment/invoice?vaultId=${vaultId}`),
    createInvoice: (data) =>
        api.post('/vault-payment/invoice', data),
    getSummary: (vaultId) =>
        api.get(`/vault-payment/summary?vaultId=${vaultId}`),
    useFreeSeat: (data) =>
        api.post('/vault-payment/use-free-seat', data),
};

export default vaultPaymentService;
